// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes avMode__overlay__off {
  from {
    background: var(--av-overlay-background-gradient, var(--av-overlay-background, var(--overlay-background-gradient, var(--overlay-background))));
    opacity: var(--av-overlay-opacity);
  }
  to {
    background: var(--overlay-background-gradient, var(--overlay-background));
    opacity: var(--overlay-opacity);
  }
}
@keyframes avMode__overlay__on {
  from {
    background: var(--overlay-background-gradient, var(--overlay-background));
    opacity: var(--overlay-opacity);
  }
  to {
    background: var(--av-overlay-background-gradient, var(--av-overlay-background, var(--overlay-background-gradient, var(--overlay-background))));
    opacity: var(--av-overlay-opacity);
  }
}
.av-mode.av-mode__overlay {
  background: var(--overlay-background-gradient, var(--overlay-background));
  opacity: var(--overlay-opacity);
}
.av-mode.av-mode__overlay.av-mode__off {
  animation: 1.2s avMode__overlay__off forwards;
}
.av-mode.av-mode__overlay.av-mode__on {
  animation: 1.2s avMode__overlay__on forwards;
}`, "",{"version":3,"sources":["webpack://./src/Common/components/shared.bundle/always-visible-mode/av-mode__overlay.scss"],"names":[],"mappings":"AAYA;EACE;IAVA,8IAAA;IACA,kCAAA;EAAA;EAaA;IATA,yEAAA;IACA,+BAAA;EADA;AACF;AAaA;EACE;IAfA,yEAAA;IACA,+BAAA;EAKA;EAaA;IAxBA,8IAAA;IACA,kCAAA;EAcA;AACF;AAcE;EAzBA,yEAAA;EACA,+BAAA;AAcF;AAaI;EACE,6CAAA;AAXN;AAcI;EACE,4CAAA;AAZN","sourcesContent":["@import './av-mode__vars.scss';\n\n@mixin on() {\n  background: var(--av-overlay-background-gradient, var(--av-overlay-background, var(--overlay-background-gradient, var(--overlay-background))));\n  opacity: var(--av-overlay-opacity);\n}\n\n@mixin off() {\n  background: var(--overlay-background-gradient, var(--overlay-background));\n  opacity: var(--overlay-opacity);\n}\n\n@keyframes avMode__overlay__off {\n  from {\n    @include on;\n  }\n\n  to {\n    @include off;\n  }\n}\n\n@keyframes avMode__overlay__on {\n  from {\n    @include off;\n  }\n\n  to {\n    @include on;\n  }\n}\n\n.av-mode {\n  &.av-mode__overlay {\n    @include off;\n\n    &.av-mode__off {\n      animation: $animation-duration avMode__overlay__off forwards;\n    }\n\n    &.av-mode__on {\n      animation: $animation-duration avMode__overlay__on forwards;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
